<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE REGIONAL'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label ><small v-show="form.nome.required" class="text-danger">*</small> Regional:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome da Regional'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"
                          list="lista">list="lista"</b-form-input>
          <table>
            <tr v-for="func in form" :key="func.nomeFuncionario"></tr>
          </table>
          </div>
        </div>

        <div class="col-md-6">
          <label><small v-show="form.funcionariosId.required" class="text-danger">*</small> Superintendentes Regionais:</label>
          <div class="input-group">
            <v-select v-model="form.funcionariosId.value"
                      :options="form.funcionariosId.options" class="w-100"
                      label="text"
                      multiple
                      :reduce="(opt) => opt.value">
              <template v-slot:no-options>Nenhum funcionário encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import RegionalModel from '@/shared/models/configurations/regionalmodel.js'
import RegionalForms from './regionalAdd-form.js'
import RegionalRepository from '@/shared/http/repositories/configurations/regional.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'

export default {
  name: 'RegionalAdd',
  mixins: [ActionsForm],
  data () {
    return {
      form: RegionalForms,
      data: RegionalModel
    }
  },
  created () {
    this.loadFuncionariosNames()
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.funcionariosId.value = obj.regionais
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.regionais = this.form.funcionariosId.value
      RegionalRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.regionais = this.form.funcionariosId.value
      this.data.id = parseInt(this.data.id)
      RegionalRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    loadFuncionariosNames () {
      loading.push()
      EmployeeRepository.GetAll()
        .then((response) => {
          this.form.funcionariosId.options = this.onResultDropdown(response, null, f => f.pessoa.nome)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/regional/components/add/regionalAdd.vue